/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Settings_MisaInputs */

const vi_einvoice_settings_misa = /** @type {(inputs: Einvoice_Settings_MisaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA meInvoice`)
};

/**

* @param {Einvoice_Settings_MisaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_settings_misa = /** @type {((inputs?: Einvoice_Settings_MisaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Settings_MisaInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_settings_misa(inputs)
});